var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: _vm.color,
        viewBox: "0 0 28 37.24",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M12.27,36.4C8.53,31.72,0,20.38,0,14,0,6.27,6.27,0,14,0s14,6.27,14,14c0,6.37-8.53,17.72-12.27,22.4-.9,1.12-2.56,1.12-3.46,0M9.96,11.67c-.83,1.44-.83,3.22,0,4.67.83,1.44,2.37,2.33,4.04,2.33s3.21-.89,4.04-2.33c.83-1.44.83-3.22,0-4.67-.83-1.44-2.38-2.33-4.04-2.33s-3.21.89-4.04,2.33",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }